export const config = {
  // Your Github Token (without Base64 encoding)
  githubConvertedToken: "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",

  // Your Github UserName
  githubUserName: "JayAI623",

  // Your Github Repo Name Where You Have your issues as Blog
  githubRepo: "blog-posts",

  // OAuth Settings
  enableOAuth: true,
  OAuthClientID: "Iv23lidJzAwkBaLYsFoR",
  OAuthSecret: "cd9fd2f25f8f0bcfafc02e772f524ea0b0a1c1fc",

  // Your Personal Blog Title
  title: "Jay's Tech Blog",

  // Your Personal Blog Subtitle
  subtitle: "AI & Technology Explorer",

  // Header customization
  header: {
    backgroundColor: '#f8f9fa',
    backgroundColorDark: '#343a40',
    titleColor: '#007bff',
    titleColorDark: '#61dafb',
    subtitleColor: '#6c757d',
    subtitleColorDark: '#adb5bd',
  },

  // Blog categories
  categories: [
    "技术",
    "AI",
    "编程",
    "学习笔记",
    "项目开发"
  ],

  // Social media links
  socialLinks: {
    github: "https://github.com/JayAI623",
    email: "mailto:zheliu.jay@gmail.com"  
  }
};
